export default __webpack_public_path__ + "static/media/ang.cc270135.png";